/**
 * events selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

interface State {
    reportsHarvestInspectionsPeople: {
        [string]: Record<string, any>
    };
}

interface Props {
    personId: ?number;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectReportsHarvestInspectionsPeople = (state: State) =>
    state.reportsHarvestInspectionsPeople;
const selectPersonId = (state: State, props: Props) => `${props.personId}`;

const selectReportsHarvestInspectionsPeopleArray = createDeepEqualSelector(
    selectReportsHarvestInspectionsPeople,
    reportsHarvestInspectionsPeopleState =>
        Object.values(reportsHarvestInspectionsPeopleState)
);

const selectReportsHarvestInspectionsPerson = createDeepEqualSelector(
    selectReportsHarvestInspectionsPeople,
    selectPersonId,
    (reportsHarvestInspectionsPeopleState, personIdState) =>
        personIdState && reportsHarvestInspectionsPeopleState[personIdState]
);

const makeSelectReportsHarvestInspectionsPersonValue = (field: string) =>
    createDeepEqualSelector(
        selectReportsHarvestInspectionsPerson,
        reportsHarvestInspectionsPersonState =>
            reportsHarvestInspectionsPersonState &&
            reportsHarvestInspectionsPersonState[field]
    );

export {
    selectReportsHarvestInspectionsPeople,
    selectReportsHarvestInspectionsPeopleArray,
    selectReportsHarvestInspectionsPerson,
    makeSelectReportsHarvestInspectionsPersonValue
};
